import React, { useState } from "react";
import { Form, Message, useToaster } from "rsuite";
import EditIcon from "@rsuite/icons/Edit";
import axiosInstance from "../../../../../../appHelpers/axiosInstance";
import { useAuth0 } from "@auth0/auth0-react";
import Modal from "../../../../../ui/Modal/Modal";
import Button from "../../../../../ui/Button/Button";
import Input from "../../../../../ui/Input/Input";
import Picker from "../../../../../ui/Picker/Picker";
import styled from "styled-components";
import { colors } from "../../../../../ui/theme/colors";

export const EditSystem = ({ sites, system, update, setUpdate }) => {
  const { getAccessTokenSilently } = useAuth0();
  const toaster = useToaster();
  const initFormSite = {
    id: system.id,
    site_id: system.site_id,
    cus_sys_id: system.cus_sys_id,
    room: system.room,
    model: system.model,
    serial_number: system.serial_number,
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open, setOpen] = useState(false);
  const [formValue, setFormValue] = useState(initFormSite);
  const message = (
    <Message showIcon type="success" header="Success">
      You successfully updated {system?.id}.
    </Message>
  );

  const onSubmit = async () => {
    try {
      const token = await getAccessTokenSilently({
        audience: `${process.env.REACT_APP_AUTH0_EXPRESS_API}`,
      });

      const response = await axiosInstance({
        method: "POST",
        url: `/customer/update/system/`,
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
        data: JSON.stringify({
          customer_id: system.customer_id,
          system: formValue,
        }),
      });
      setUpdate(!update);
      // setResMsg(response.data);
      toaster.push(message, "topCenter");
      handleClose();
    } catch (error) {
      console.error(error);
      toaster.push(errMessage, "topCenter");
    }
  };

  return (
    <>
      <EditButton onClick={handleOpen}>
        <EditIcon style={{ fontSize: "16px" }} />
      </EditButton>

      <Modal
        open={open}
        onClose={handleClose}
        title={`Edit System: ${system?.id}`}
        size="md"
        showFooter={true}
        footerActions={
          <StyledFooterActions>
            <Button variant="subtle" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onSubmit}>
              Update System
            </Button>
          </StyledFooterActions>
        }
      >
        <ModalContent>
          <FormRow>
            <FormGroup>
              <Label>System ID</Label>
              <Input value={formValue.id} disabled placeholder="System ID" />
            </FormGroup>
          </FormRow>

          <FormRow>
            <Picker
              label="Site"
              data={sites}
              value={formValue.site_id}
              onChange={(value) =>
                setFormValue({ ...formValue, site_id: value })
              }
              placeholder="Select site"
              searchable={true}
              cleanable={true}
            />
          </FormRow>

          <FormRow>
            <FormGroup>
              <Label>CUID</Label>
              <Input
                value={formValue.cus_sys_id}
                onChange={(value) =>
                  setFormValue({ ...formValue, cus_sys_id: value })
                }
                placeholder="Customer System ID"
              />
            </FormGroup>
          </FormRow>

          <FormRow>
            <FormGroup>
              <Label>Room</Label>
              <Input
                value={formValue.room}
                onChange={(value) =>
                  setFormValue({ ...formValue, room: value })
                }
                placeholder="Room location"
              />
            </FormGroup>
          </FormRow>

          <FormRow>
            <FormGroup>
              <Label>Model</Label>
              <Input
                value={formValue.model}
                onChange={(value) =>
                  setFormValue({ ...formValue, model: value })
                }
                placeholder="System model"
              />
            </FormGroup>
          </FormRow>

          <FormRow>
            <FormGroup>
              <Label>Serial Number</Label>
              <Input
                value={formValue.serial_number}
                onChange={(value) =>
                  setFormValue({ ...formValue, serial_number: value })
                }
                placeholder="Serial number"
              />
            </FormGroup>
          </FormRow>
        </ModalContent>
      </Modal>
    </>
  );
};

const errMessage = (
  <Message showIcon type="error" header="Error">
    Something went wrong. Please try again.
  </Message>
);

const EditButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: ${colors.neutral[100]};
  color: ${colors.neutral[600]};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${colors.neutral[200]};
    color: ${colors.neutral[700]};
  }

  &:active {
    transform: scale(0.95);
  }
`;

const ModalContent = styled.div`
  padding: 24px;
`;

const StyledFooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const FormRow = styled.div`
  margin-bottom: 20px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.neutral[700]};
  margin-bottom: 4px;
`;
